import { render, staticRenderFns } from "./AssignSubjects.vue?vue&type=template&id=af7d2dfc&scoped=true&lang=true&"
import script from "./AssignSubjects.vue?vue&type=script&lang=js&"
export * from "./AssignSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7d2dfc",
  null
  
)

export default component.exports